<div *ngIf="showModal"
     class="blur-modal-backdrop"
     [class.fade-in]="!isClosing"
     [class.fade-out]="isClosing"
     (click)="close()">
</div>

<div *ngIf="showModal"
     class="mantis-modal user-training-activity-details-modal"
     role="dialog"
     aria-modal="true"
     [class.modal-in]="!isClosing"
     [class.modal-out]="isClosing">
    <div class="modal-dialog activity-details-modal"
         (click)="$event.stopPropagation()"
         style="max-width: 560px; max-height: 70vh; display: flex; flex-direction: column;">
        <div class="modal-header d-flex justify-content-between align-items-center" style="flex-shrink: 0;">
            <h5 class="mb-0 fw-bold">Activity details</h5>
            <button type="button" class="btn-close" (click)="close()" title="Close">
                <img src="assets/common/ic_x_s_size.svg" alt="Close">
            </button>
        </div>

        <div class="modal-body" style="padding: 1.5rem; overflow-y: auto; flex: 1; min-height: 0;">
            <div *ngIf="isLoading" class="text-center py-4">
                <p class="text-muted mb-0">Loading activity details...</p>
            </div>

            <div *ngIf="!isLoading && activityDetails">
                <div class="mb-4">
                    <div class="d-flex align-items-center gap-2 mb-2">
                        <span class="badge badge-workout">Workout</span>
                        <span class="meta text-muted small">
                            {{ activityDetails.created_at | dateFormat:'dateTimeShort' }}
                        </span>
                    </div>
                    <div class="activity-title mb-2">
                        {{ activityDetails.training_name }}
                    </div>
                    <div *ngIf="activityDetails.program_name" class="from-program">
                        Program: {{ activityDetails.program_name }}
                    </div>
                </div>

                <div class="mb-4">
                    <div class="row g-3">
                        <div *ngIf="activityDetails.exercises_completed" class="col-6">
                            <div class="workout-metric-card">
                                <div class="metric-icon">
                                    <img src="assets/activity/ic_exercises_circle.svg" alt="Exercises">
                                </div>
                                <div class="metric-content">
                                    <div class="metric-label">Exercises</div>
                                    <div class="metric-value">{{ activityDetails.exercises_completed }}</div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="activityDetails.time_in_seconds" class="col-6">
                            <div class="workout-metric-card">
                                <div class="metric-icon">
                                    <img src="assets/activity/ic_duration_circle.svg" alt="Duration">
                                </div>
                                <div class="metric-content">
                                    <div class="metric-label">Duration</div>
                                    <div class="metric-value">{{ formatDuration(activityDetails.time_in_seconds) }}</div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="activityDetails.intensity" class="col-6">
                            <div class="workout-metric-card">
                                <div class="metric-icon">
                                    <img src="assets/activity/ic_intensity_circle.svg" alt="Intensity">
                                </div>
                                <div class="metric-content">
                                    <div class="metric-label">Intensity</div>
                                    <div class="metric-value">{{ formatIntensity(activityDetails.intensity) }}</div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="activityDetails.readiness_level" class="col-6">
                            <div class="workout-metric-card">
                                <div class="metric-icon">
                                    <img src="assets/activity/ic_readiness_circle.svg" alt="Readiness">
                                </div>
                                <div class="metric-content">
                                    <div class="metric-label">Readiness</div>
                                    <div class="metric-value">{{ activityDetails.readiness_level }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-4" *ngIf="activityDetails.comment">
                    <div class="fw-bold mb-2">Client feedback</div>
                    <div class="client-feedback-block pt-2 px-3 pb-2 border-start border-secondary border-3 rounded-0">
                        {{ activityDetails.comment }}
                    </div>
                </div>

                <div *ngIf="activityDetails.exercises?.length">
                    <div class="fw-bold mb-3">Workout details</div>
                    <div class="workout-details-list">
                        <div *ngFor="let exercise of activityDetails.exercises" class="exercise-item mb-3">
                            <div class="exercise-name fw-bold mb-2">
                                {{ exercise.name }}
                            </div>
                            <div class="exercise-sets">
                                <div *ngFor="let entry of exercise.entries" class="set-item mb-1">
                                    <span class="set-label">Set {{ entry.set_number }} / Rnd {{ entry.round_number }}:</span>
                                    <span *ngIf="entry.number_of_reps">{{ entry.number_of_reps }} reps</span>
                                    <span *ngIf="entry.number_of_reps && (entry.weight_in_kilograms_float || entry.time_in_seconds)"> • </span>
                                    <span *ngIf="entry.weight_in_kilograms_float">{{ entry.weight_in_kilograms_float | weightKg }} kg</span>
                                    <span *ngIf="entry.weight_in_kilograms_float && entry.time_in_seconds"> • </span>
                                    <span *ngIf="entry.time_in_seconds">{{ formatTime(entry.time_in_seconds) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
